export default __webpack_public_path__ + "static/media/gst.91c5cd43.jpg";